import { Accordion as MantineAccordion, AccordionProps as MantineAccordionProps } from '@mantine/core';
import { cva, VariantProps } from 'class-variance-authority';

import styles from './Accordion.module.css';
import { JSX } from 'react';

const accordionVariants = cva(styles.base, {
    variants: {
        variant: {
            default: styles.default,
            contained: styles.contained,
        },
    },
});

export type AccordionProps = MantineAccordionProps & VariantProps<typeof accordionVariants>;

/**
 * Use Object.assign to add the static properties of MantineAccordion to the Accordion component
 * This is necessary because Accordion is a functional component and does not have static properties by default.
 * This allows us to use the Accordion.Item, Accordion.Panel, and Accordion.Control components as static properties of the Accordion component.
 */
export const Accordion: typeof MantineAccordion & {
    (props: AccordionProps): JSX.Element;
} = Object.assign(({ children, variant, ...props }: AccordionProps) => {
    return (
        <MantineAccordion order={4} className={accordionVariants({ variant })} {...props}>
            {children}
        </MantineAccordion>
    );
}, MantineAccordion);
